import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import Blog from "./Pages/Blog";
import DevUpdatesPage from "./Pages/DevUpdatesPage";
import Post from "./Pages/Post";
import PageNotFound from "./Pages/PageNotFound";
import MakePost from "./Pages/MakePost";
import DeletePost from "./Pages/DeletePosts"
import Login from "./Pages/LogIn";
import PrivateRoute from "./Components/PrivateRoute";
import { AuthProvider } from "./Components/Auth";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/devlog" element={<DevUpdatesPage />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/404" element={<PageNotFound />} />
          <Route path="/makepost" element={<PrivateRoute><MakePost /></PrivateRoute>} />
          <Route path="/delpost" element={<PrivateRoute><DeletePost /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
